import apiRequestService from '@/commonProject/service/apiRequestService';

export default class setupUserRepository {
    /**
     * ユーザー情報詳細設定APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async putUserDetailActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/usrdtl', requestBody, idToken);
        return result;
    }
}
